import { useContext } from "react";

import ProposalInputContext from "../../../context/ProposalInputContext";

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';

import ExpandableSectionHeader from "./ExpandableSectionHeader";


const CustomerInfoForm = () => {
  const {
    values, setValues, formErrors, collapseValues, setCollapseValue, sectionStyle
  } = useContext(ProposalInputContext);

  return (
    <Grid container spacing={2} sx={sectionStyle}>
      <ExpandableSectionHeader
        sectionTitle='3. Customer Information'
        showSection='showCustomerInfo'
        icon={<PeopleAltOutlinedIcon sx={{ color: "text.secondary" }} />}
        collapseValues={collapseValues}
        setCollapseValue={setCollapseValue}
      />

      {collapseValues?.showCustomerInfo &&
        <>
          <Grid size={{ xs: 6 }}>
            <TextField
              variant="outlined"
              label="Customer full name *"
              name='customerName'
              value={values?.customerName}
              onChange={e =>
                setValues(prev => ({
                  ...prev,
                  customerName: e.target.value
                }))
              }
              helperText={formErrors['customerName']}
              error={'customerName' in formErrors}
              fullWidth
            />
          </Grid>

          <Grid size={{ xs: 6 }}>
            <TextField
              variant="outlined"
              label="Customer job title *"
              name='customerJobTitle'
              value={values?.customerJobTitle}
              onChange={e =>
                setValues(prev => ({
                  ...prev,
                  customerJobTitle: e.target.value
                }))
              }
              helperText={formErrors['customerJobTitle']}
              error={'customerJobTitle' in formErrors}
              fullWidth
            />
          </Grid>

          <Grid size={{ xs: 6 }}>
            <TextField
              variant="outlined"
              label="Customer email address *"
              name='customerEmailAddress'
              value={values?.customerEmailAddress}
              onChange={e =>
                setValues(prev => ({
                  ...prev,
                  customerEmailAddress: e.target.value
                }))
              }
              helperText={formErrors['customerEmailAddress']}
              error={'customerEmailAddress' in formErrors}
              fullWidth
            />
          </Grid>

          <Grid size={{ xs: 6 }}>
            <TextField
              variant="outlined"
              label="Customer main phone number *"
              name='customerPhoneNumber'
              value={values?.customerPhoneNumber}
              onChange={e =>
                setValues(prev => ({
                  ...prev,
                  customerPhoneNumber: e.target.value
                }))
              }
              helperText={formErrors['customerPhoneNumber']}
              error={'customerPhoneNumber' in formErrors}
              fullWidth
            />
          </Grid>
        </>
      }
    </Grid>
  );
};

export default CustomerInfoForm;